/**
 * Shopify Widerrufsbutton – Frontend JavaScript
 * Zweistufiger Widerrufsprozess gemäß §356a BGB.
 *
 * Beim Absenden werden zwei native Shopify-Formulare per Fetch an /contact gesendet:
 *  1. Kundenformular (form_type=customer) -> meldet den Kunden per Single Opt-in zur
 *     E-Mail-Liste an und setzt den Tag "widerruf". Dadurch tritt der Kunde in das
 *     Segment "Widerruf" ein, das eine native Marketing-Automation (Shopify Email)
 *     auslöst (Eingangsbestätigung; funktioniert für neue UND bestehende Kunden).
 *  2. Kontaktformular (form_type=contact) -> sendet die vollständigen Widerrufsdaten
 *     an die im Shop hinterlegte Benachrichtigungs-E-Mail (Händler).
 */
(function () {
  'use strict';

  var data = window.wrData || {};

  var form           = document.getElementById('wr-widerruf-form');
  var submitBtn      = document.getElementById('wr-submit-btn');
  var errorMsg       = document.getElementById('wr-error-msg');
  var backdrop       = document.getElementById('wr-modal-backdrop');
  var confirmBtn     = document.getElementById('wr-confirm-btn');
  var cancelBtn      = document.getElementById('wr-cancel-btn');
  var confirmSpinner = document.getElementById('wr-confirm-spinner');
  var summary        = document.getElementById('wr-summary');
  var formSection    = document.getElementById('wr-form-section');
  var successSection = document.getElementById('wr-success-section');

  if (!form) return;

  // ----------------------------------------
  // Stufe 1: Formular validieren -> Modal
  // ----------------------------------------
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hideError();
    if (!validateForm()) return;
    buildSummary();
    openModal();
  });

  cancelBtn.addEventListener('click', closeModal);

  backdrop.addEventListener('click', function (e) {
    if (e.target === backdrop) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && backdrop.classList.contains('is-open')) closeModal();
  });

  // ----------------------------------------
  // Stufe 2: Bestätigung -> native Shopify-Submits
  // ----------------------------------------
  confirmBtn.addEventListener('click', function () {
    // Honeypot: Bei Ausfüllung still abbrechen (Erfolg simulieren).
    var hp = form.querySelector('[name="wr_hp"]');
    if (hp && hp.value) {
      closeModal();
      showSuccess();
      return;
    }

    setConfirmLoading(true);

    var v = val;

    // (1) Kundenformular -> Flow-Auslöser
    var customerData = new FormData();
    customerData.append('form_type', 'customer');
    customerData.append('utf8', '\u2713');
    customerData.append('contact[tags]', data.customerTag || 'widerruf');
    customerData.append('contact[email]', v('wr_email'));
    customerData.append('contact[first_name]', v('wr_vorname'));
    customerData.append('contact[last_name]', v('wr_nachname'));

    // (2) Kontaktformular -> vollständige Daten an den Händler
    var contactData = new FormData();
    contactData.append('form_type', 'contact');
    contactData.append('utf8', '\u2713');
    contactData.append('contact[email]', v('wr_email'));
    contactData.append('contact[name]', v('wr_vorname') + ' ' + v('wr_nachname'));
    contactData.append('contact[' + (data.labels.contract || 'Vertragsnummer') + ']', v('wr_vertragsnummer'));
    appendIf(contactData, data.labels.date, v('wr_bestelldatum'));
    var adresse = [v('wr_strasse'), [v('wr_plz'), v('wr_ort')].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    appendIf(contactData, 'Adresse', adresse);
    appendIf(contactData, data.labels.notes, v('wr_anmerkungen'));
    contactData.append('contact[body]', buildBody(v));

    var post = function (body) {
      // WICHTIG: Shopifys /contact akzeptiert KEIN multipart/form-data (führt zu
      // HTTP 400). Die FormData wird daher in application/x-www-form-urlencoded
      // umgewandelt (URLSearchParams kodiert Sonderzeichen wie ✓, / und Leerzeichen).
      return fetch(data.contactUrl, {
        method: 'POST',
        body: new URLSearchParams(body).toString(),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': 'text/html'
        }
      }).then(function (response) {
        // fetch() lehnt nur bei Netzwerkfehlern ab. Shopify antwortet bei
        // Erfolg mit einer Weiterleitung (302 -> gefolgt -> 200) und bei
        // ungültiger Eingabe mit einem Fehlerstatus (z. B. 422). Daher den
        // Status explizit prüfen, damit kein falscher Erfolg gemeldet wird.
        if (!response.ok) {
          throw new Error('Shopify-Formular antwortete mit Status ' + response.status);
        }
        return response;
      });
    };

    Promise.all([post(customerData), post(contactData)])
      .then(function () {
        setConfirmLoading(false);
        closeModal();
        if (data.redirectUrl) {
          window.location.href = data.redirectUrl;
        } else {
          showSuccess();
        }
      })
      .catch(function () {
        setConfirmLoading(false);
        closeModal();
        showError(data.networkErrorMsg);
      });
  });

  // ----------------------------------------
  // Hilfsfunktionen
  // ----------------------------------------
  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function appendIf(fd, label, value) {
    if (value) fd.append('contact[' + label + ']', value);
  }

  function buildBody(v) {
    var heading = data.subjectMerchant || 'Neuer Widerruf eingegangen';
    var lines = [heading, '================================', ''];
    lines.push((data.labels.firstname || 'Vorname') + ': ' + v('wr_vorname'));
    lines.push((data.labels.lastname || 'Nachname') + ': ' + v('wr_nachname'));
    lines.push((data.labels.email || 'E-Mail') + ': ' + v('wr_email'));
    lines.push((data.labels.contract || 'Vertragsnummer') + ': ' + v('wr_vertragsnummer'));
    if (v('wr_bestelldatum')) lines.push((data.labels.date || 'Bestelldatum') + ': ' + v('wr_bestelldatum'));
    var adresse = [v('wr_strasse'), [v('wr_plz'), v('wr_ort')].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    if (adresse) lines.push('Adresse: ' + adresse);
    if (v('wr_anmerkungen')) lines.push((data.labels.notes || 'Anmerkungen') + ': ' + v('wr_anmerkungen'));
    return lines.join('\n');
  }

  function validateForm() {
    var valid = true;
    var required = form.querySelectorAll('[required]');
    required.forEach(function (field) {
      field.style.borderColor = '';
      if (!field.value.trim()) {
        field.style.borderColor = '#e53e3e';
        valid = false;
      }
    });

    var emailField = document.getElementById('wr_email');
    if (emailField && emailField.value && !isValidEmail(emailField.value)) {
      emailField.style.borderColor = '#e53e3e';
      valid = false;
    }

    if (!valid) {
      showError(data.errorMsg);
      var first = form.querySelector('[required][style*="e53e3e"]');
      if (first) first.focus();
    }
    return valid;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function buildSummary() {
    var labels = data.labels || {};
    var fields = [
      { label: labels.firstname, id: 'wr_vorname' },
      { label: labels.lastname,  id: 'wr_nachname' },
      { label: labels.contract,  id: 'wr_vertragsnummer' },
      { label: labels.email,     id: 'wr_email' },
      { label: labels.date,      id: 'wr_bestelldatum' },
      { label: labels.street,    id: 'wr_strasse' },
      { label: labels.zip,       id: 'wr_plz' },
      { label: labels.city,      id: 'wr_ort' },
      { label: labels.notes,     id: 'wr_anmerkungen' }
    ];

    var html = '';
    fields.forEach(function (f) {
      var el = document.getElementById(f.id);
      if (el && el.value.trim()) {
        html += '<dt>' + escHtml(f.label) + '</dt>';
        html += '<dd>' + escHtml(el.value.trim()) + '</dd>';
      }
    });
    summary.innerHTML = html;
  }

  function openModal() {
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { confirmBtn.focus(); }, 50);
  }

  function closeModal() {
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    submitBtn.focus();
  }

  function showSuccess() {
    formSection.style.display = 'none';
    successSection.style.display = 'block';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function showError(msg) {
    errorMsg.textContent = msg;
    errorMsg.style.display = 'block';
  }

  function hideError() {
    errorMsg.style.display = 'none';
  }

  function setConfirmLoading(loading) {
    confirmBtn.disabled = loading;
    if (confirmSpinner) confirmSpinner.style.display = loading ? 'block' : 'none';
  }

  function escHtml(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str == null ? '' : str));
    return d.innerHTML;
  }
})();
